<template>
    <template v-if="iconRef">
        <span v-if="tooltipRef" v-tooltip="tooltipRef">
            <FontAwesomeIcon :icon="iconRef" />
        </span>
        <span v-else>
            <FontAwesomeIcon :icon="iconRef" />
        </span>
    </template>
</template>

<script setup lang="ts">
import { defineProps, onMounted, ref, watch } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library, IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface Props {
    icon: IconDefinition;
    tooltip?: string | object;
}

const props = defineProps<Props>();

const iconRef = ref<IconDefinition>(props.icon);
const tooltipRef = ref<string | object | undefined>(props.tooltip);

const handleIcon = (newIcon: IconDefinition) => {
    try {
        library.add(newIcon);

        iconRef.value = newIcon;
    } catch (error: any) {
        console.error(`Error importing icon: ${error.message}`);
    }
};

watch(() => props.icon, (newValue: IconDefinition) => {
    handleIcon(newValue);
});

watch(() => props.tooltip, (newValue: string | object | undefined) => {
    tooltipRef.value = newValue;
});

onMounted(() => {
    handleIcon(props.icon);
});
</script>